export default {
  color: 'black',
  elevation: 0,
  ripple: false,
  dark: true
};
